module.exports = __webpack_public_path__ + "static/Averta-Semibold-0de26cf78aee8cf0ee25af57c711f930.eot";